import React, { useEffect } from 'react';

import lottie from 'lottie-web/build/player/lottie';

import LogoHeader from '../../animations/brick_logo_1';

const HeaderLogo = props => {

    useEffect(() => {

        let logoAnim;
 
         logoAnim = lottie.loadAnimation({
             container: document.getElementById('bo_header_logo'), // Required
             animationData: LogoHeader, // Required
             renderer: 'svg', // Required
             loop: true, // Optional
             autoplay: true, // Optional
             name: "Hello World", // Name for future reference. Optional.
             rendererSettings:{ 
                 preserveAspectRatio:'xMidYMid meet',
                 className: 'logoHeader_canvas'
             }
             });



        

    }, []);

    return (
            <div id="bo_header_logo"></div>

     );


};

export default HeaderLogo;